export default "__VITE_ASSET__DtZKAf7s__"